






import DealerSearch from "./components/DealerSearch.vue";

export default {
    name: "App",
    components: {
        DealerSearch
    },
};
